import React, { Component } from "react";
import { connect } from "react-redux";
import EachItem from "./EachItem";
class ItemSender extends Component {
  render() {
    // let x = this.props.map[this.props.cat];       //Sending every item for display
    let itemList;
    if (this.props.isVeg === true) itemList = this.props.mapV[this.props.cat];
    else itemList = this.props.mapAll[this.props.cat];

    /*   click2={() => this.props.click1(e.itemId)}
          del={() => this.props.del(e.itemId)}
          cart={this.props.cart}
          key={e.itemId}*/
    // console.log("itemSender");
    const y = itemList.map(e => {
      return <EachItem key={e.itemId} menu={e} />;
    });

    return <div style={{ marginTop: "160px", marginBottom: "70px" }}>{y}</div>;
  }
}
const mapStateToProps = state => {
  return {
    mapV: state.menuR.vegMap,
    mapAll: state.menuR.Category,
    isVeg: state.menuR.isVeg,
    isLoading: state.menuR.isLoading
  };
};
export default connect(mapStateToProps)(ItemSender);
